import * as types from './mutation-types'
import axios from 'axios'
import cmnConst from '@/assets/js/constant.js'

const uri = `${cmnConst.API_URL}/api/v3/`

export default {
	namespaced: true,

	state: {
		resultOfAnalysisData: null
	},

	mutations: {
		[types.SET_RESULT_OF_ANALYSIS_DATA] (state, resultOfAnalysisData) {
			state.resultOfAnalysisData = resultOfAnalysisData
		}
	},

	actions: {
		// おしえてAI分析結果を取得するAPI
		[types.SET_RESULT_OF_ANALYSIS_DATA] ({ commit }, payload) {
			return new Promise((resolve, reject) => {
				axios.request({
					method: 'get',
					url: `${uri}pain/type.json`,
					params: {
						user_id: payload.user_id,
						user_token: payload.user_token,
						record_count: payload.count // 特定の分析結果を取得する場合は「record_count」を使用する
					}
				}).then(res => {
					// NOTE: result_codeが1001以外はエラー
					if (res.data.result_code !== 1001) {
						commit(types.SET_RESULT_OF_ANALYSIS_DATA, null)
						reject(res)
					} else {
						const data = res.data
						commit(types.SET_RESULT_OF_ANALYSIS_DATA, data)
						resolve(data)
					}
				}).catch(error => {
					commit(types.SET_RESULT_OF_ANALYSIS_DATA, null)
					reject(error)
				})
			})
		}
	},

	getters: {
		resultOfAnalysisData (state) {
			return state.resultOfAnalysisData
		}
	}
}
